<template>
  <el-image
    :src="devImgs[name]"
    :style="{
      width: width ? width + 'px' : undefined,
      height: height ? height + 'px' : undefined,
    }"
    :preview-src-list="[devImgs[name]]"
  >
  </el-image>
</template>
<script>
export default {
  name: "deviceImage",
  props: {
    name: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      devImgs: {
        Y001S: require("@/assets/images/pic_watch2@2x.png"),
        Y006: require("@/assets/images/pic_watch2@2x(1).png"),
        Y905S: require("@/assets/images/pic_watch3@2x.png"),
        Y906S: require("@/assets/images/pic_watch@2x.png"),
        "GP-3002": require("@/assets/images/pic_gxa4gbpkit@2x.png"),
        "Mini lite": require("@/assets/images/pic_picooc@2x.png"),
        "Smart Body": require("@/assets/images/pic_yhebfs@2x.png"),
        G7: require("@/assets/images/pic_bioland@2x.png"),
        "G-777G": require("@/assets/images/pic_ridex@2x.png"),
        Y007: require("@/assets/images/pic_watch_y007@2x.png"),
        S3: require("@/assets/images/pic_S3@2x.png"),
        K300: require("@/assets/images/pic_S3@2x.png"),
        Y003: require("@/assets/images/bpdoctor_y003@2x.png"),
        Y908S: require("@/assets/images/pic_watch_y908s@2x.png"),
      },
    };
  },
};
</script>
<style></style>
